import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';

import { TDesktopESimInstruction } from 'pages/TariffsCatalog2021/components/BuySimModal/types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

// Второй экран-заглушка с инфой о покупке есим в приложении для десктопных юзеров
export const DesktopESimInstruction: FC<TDesktopESimInstruction> = ({ title, steps, info }) => {
  return (
    <div>
      <Text className={cx('title')}>{title}</Text>
      <div className={cx('info')}>
        <Text className={cx('info-title')}>{info.title}</Text>
        <img alt="" className={cx('info-qr-code')} src={info.qrCode} />
        <Text className={cx('info-text')}>{info.text}</Text>
      </div>
      <div className={cx('steps')}>
        {steps.map((step) => (
          <div className={cx('steps-item')} key={step.title}>
            <img alt="" className={cx('steps-icon')} src={step.icon} />
            <div className={cx('steps-title')}>{step.title}</div>
            <div className={cx('steps-text')}>{step.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
